import React, {useCallback, useMemo, useState} from "react";
import "./index.scss";
import Button from "features/components/button";
import {__} from "services/i18n";
import {bool, func, number, object, oneOfType, string} from "prop-types";

export const Stepper = (props) => {
    const {children, onComplete, startIndex, onBack} = props;
    const [index, setIndex] = useState(startIndex || 0);

    React.useEffect(() => {
        setIndex(startIndex || 0);
    }, [startIndex, setIndex]);

    const number_of_pages = children.length ?? 1;

    const first_page = index === 0;
    const last_page = index === number_of_pages - 1;
    const current_child = number_of_pages === 1 ? children : children[index];
    const goBack = useCallback(() => {
        if(onBack) {
            onBack();
        }
        setIndex(index - 1);
    }, [index, setIndex, onBack]);

    React.useEffect(() => {
        window.scrollTo(0,0);
    }, [index]);

    const goNext = useCallback(() => {
        if (!last_page) {
            if(current_child.props.stepperDoneFunc) {
                current_child.props.stepperDoneFunc();
            } else {
                setIndex(index + 1);
            }
        } else {
            onComplete();
        }
    }, [index, setIndex, last_page, onComplete, current_child]);

    const isCurrentValid = useMemo(() => {
        return current_child.props.stepperValidation ? current_child.props.stepperValidation() : true;
    }, [current_child]);

    const currentTitle = useMemo(() => {
        return current_child.props.stepperTitle ? current_child.props.stepperTitle : __("buttons.next-step");
    }, [current_child]);

    const currentLoading = useMemo(() => {
        return current_child.props.stepperLoading || false;
    }, [current_child]);

    const currentStatus = useMemo(() => {
        return currentLoading ? "loading" : (last_page ? "success" : null);
    }, [currentLoading, last_page]);

    return <div className={"stepper"}>
        <div className={"child"}>
            {current_child}
        </div>
        <div className={`actions ${first_page ? "first_page" : ""} ${last_page ? "last_page" : ""}`}>
            <Button title={""} onClick={goBack} type={"square"} icon={"arrow-left"} />
            <Button title={currentTitle} onClick={goNext} disabled={!isCurrentValid} status={currentStatus} icon={last_page ? "check-circle-outline" : "arrow-right"} />
        </div>
    </div>
};

Stepper.propTypes = {
    onComplete: func.isRequired,
    startIndex: number
};

export const StepperStep = (props) => {
    return <div>
        {props.children}
    </div>
}

StepperStep.propTypes = {
    stepperTitle: oneOfType([string, object]),
    stepperValidation: func,
    stepperLoading: bool,
    stepperDoneFunc: func
}